import { useTranslation } from 'react-i18next';
import { LoadingIndicator } from '@asset-metrix/portal-ui';

import styles from './dashboardEmptyState.module.scss';

export function DashboardLoadingState() {
  const { t } = useTranslation();

  return (
    <div className={styles.root} data-testid="dashboard-loading">
      <div className={styles.content}>
        <LoadingIndicator size="2em" />
        <p className={styles.description}>{t('app.dashboard.loading')}</p>
      </div>
    </div>
  );
}
